// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-RightSide-module--cls1--2AA6E","cls2":"contacts-RightSide-module--cls2--CcXpa contacts-RightSide-module--cls1--2AA6E"};